namespace $ {

	$mol_style_define( $shm_projects_codex, {
		Menu_page: {
			flex: { basis: '22rem', grow: 0, shrink: 0 },
			minWidth: '18rem',
		},
		'@media': {
			'(max-width: 640px)': {
				Menu_page: {
					width: '100%',
					minWidth: '100%',
					flex: { basis: '100%', grow: 1, shrink: 1 },
				},
			},
		},
	} )

	$mol_style_define( $shm_projects_codex_chat, {
		width: 'auto',
		flex: { grow: 1, shrink: 1, basis: 0 },
		Prompt: {
			overflow: 'hidden',
		},
		Sessions_memory: {
			width: '100%',
		},
		Sessions_memory_value: {
			color: $mol_theme.shade,
		},
		Sessions_page: {
			flex: { basis: '22rem', grow: 0, shrink: 0 },
			minWidth: '18rem',
		},
		Chat_page: {
			width: 'auto',
			minWidth: '34rem',
			flex: { basis: '56rem', grow: 1, shrink: 1 },
			margin: 0,
		},
		'@media': {
			'(max-width: 640px)': {
				Sessions_page: {
					width: '100%',
					minWidth: '100%',
					flex: { basis: '100%', grow: 1, shrink: 1 },
				},
				Chat_page: {
					width: '100%',
					minWidth: '100%',
					flex: { basis: '100%', grow: 1, shrink: 1 },
				},
			},
		},
	} )

}
